import {get} from "../utils";
import {getActiveChannel} from "../authentication/utils";


export default host => (id, withTimestamp = false) =>
  get(`${host}/home/elements/${id}?include=translations`,null, withTimestamp)
    .then(response => response.json())
    .then(json => json.data)